import { useEffect } from "react";
import { Monitor } from "lucide-react";
import { Button } from "../../app/components";
import MainHeader from "../Common/MainHeader/MainHeader";
import GerarSenha from "./Components/GerarSenha";
import ControleAtendete from "./Components/ControleAtendete";
import { useAuth } from "../../hooks/useAuth";
import { cleanupExpiredTickets } from "../../services/queueService";
import "./Painel.css";

const Painel = () => {
  const { user } = useAuth();
  const userId = user?.uid ?? "";

  useEffect(() => {
    if (userId) cleanupExpiredTickets(userId);
  }, [userId]);

  return (
    <>
      <MainHeader
        title="Painel de Senhas"
        subtitle="Geração, chamada e exibição em tempo real"
        icon={<Monitor size={32} />}
        children={
          <Button
            btnColor="success"
            onClick={() => window.open(`/painel-tv?uid=${userId}`, "_blank")}
            className="modern-btn d-flex align-items-center gap-2"
            style={{ borderRadius: "12px", padding: "12px 24px" }}
          >
            Abrir Painel TV
          </Button>
        }
      />

      <div className="painel-page">
        <div className="painel-grid">
          <GerarSenha userId={userId} />
          <ControleAtendete userId={userId} />
        </div>
      </div>
    </>
  );
};

export default Painel;
